import * as yup from 'yup'

export const transferBonusesSchema = yup.object().shape({
    bonus_id: yup.string().required('Выберите бонус'),
    amount: yup.number().typeError('Укажите число').min(1, 'Минимальное количество - 1 бонус').required('Укажите количество бонусов'),
})